import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useSuperAdminUsers } from "../../../context/SuperAdmin/UsersContext";

const HeadersUsersTable = () => {
  const { searchQuery, handleSearchQuery, toggleCreateModal } =
    useSuperAdminUsers();

  return (
    <Grid
      container
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      {/* Formulario de búsqueda */}
      <Grid item>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: John Doe"
          value={searchQuery}
          onChange={handleSearchQuery}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          onClick={() => toggleCreateModal(true)}
          sx={{ background: "#336B87" }}
          startIcon={<PersonAddOutlinedIcon />}
        >
          Crear usuario
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersUsersTable;
